import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6 } from "styled-components";
const _excluded = ["btnText"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { observer } from "mobx-react";
import { forwardRef } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import styled, { withTheme } from "styled-components";
import Box from "../../Styled/Box";
import Button from "../../Styled/Button";
import Icon, { StyledIcon } from "../../Styled/Icon";
import Spacing from "../../Styled/Spacing";
import Text from "../../Styled/Text";
import { ExplorerWindowElementName } from "../ExplorerWindow/ExplorerWindow";
import { useRefForTerria } from "../Hooks/useRefForTerria";
import SearchBoxAndResults from "../Search/SearchBoxAndResults";
import { useViewState, withViewState } from "../Context";
import Workbench from "../Workbench/Workbench";
import { applyTranslationIfExists } from "../../Language/languageHelpers";
import { Category, HelpAction } from "../../Core/AnalyticEvents/analyticEvents";
import { runInAction } from "mobx";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const BoxHelpfulHints = styled(Box).withConfig({
  displayName: "SidePanel__BoxHelpfulHints",
  componentId: "sc-1eptbna-0"
})(["align-self:flex-end;margin-top:auto;color:", ";"], p => p.theme.greyLighter);
const EmptyWorkbench = observer(() => {
  const {
    t
  } = useTranslation();
  const viewState = useViewState();
  const transContent = t("emptyWorkbenchInfo", {
    returnObjects: true
  });
  return /*#__PURE__*/_jsx(Box, {
    overflowY: "auto",
    scroll: true,
    column: true,
    fullWidth: true,
    children: /*#__PURE__*/_jsx(Text, {
      medium: true,
      light: true,
      children: /*#__PURE__*/_jsxs(BoxHelpfulHints, {
        column: true,
        gap: 4,
        paddedVertically: 5,
        paddedRatio: 3,
        overflowY: "auto",
        scroll: true,
        children: [transContent.map((content, idx) => /*#__PURE__*/_jsxs("div", {
          children: [content.heading && /*#__PURE__*/_jsxs(_StyledText, {
            as: "h5",
            medium: true,
            bold: true,
            children: [content.heading, " "]
          }), content.body && /*#__PURE__*/_jsx(Text, {
            medium: true,
            children: content.body
          }), content.list && /*#__PURE__*/_jsx(_StyledUl, {
            children: content.list.map(item => /*#__PURE__*/_jsx("li", {
              children: item
            }, item))
          })]
        }, idx)), /*#__PURE__*/_jsx(_StyledBox, {
          centered: true,
          children: /*#__PURE__*/_jsx(_StyledButton, {
            textLight: true,
            transparentBg: true,
            onClick: () => {
              var _viewState$terria$ana;
              (_viewState$terria$ana = viewState.terria.analytics) === null || _viewState$terria$ana === void 0 || _viewState$terria$ana.logEvent(Category.help, HelpAction.takeTour);
              runInAction(() => {
                viewState.setTourIndex(0);
              });
            },
            renderIcon: () => /*#__PURE__*/_jsx(StyledIcon, {
              light: true,
              styledWidth: "18px",
              glyph: Icon.GLYPHS.info
            }),
            textProps: {
              large: true,
              textLight: true
            },
            children: t("helpPanel.takeTour")
          })
        })]
      })
    })
  });
});
const SidePanelButton = /*#__PURE__*/forwardRef(function SidePanelButton(props, ref) {
  const {
      btnText
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
    primary: true,
    ref: ref,
    renderIcon: props.children && (() => props.children),
    textProps: {
      large: true
    }
  }, rest), {}, {
    children: btnText ? btnText : ""
  }));
});
export const EXPLORE_MAP_DATA_NAME = "ExploreMapDataButton";
export const SIDE_PANEL_UPLOAD_BUTTON_NAME = "SidePanelUploadButton";
const SidePanel = observer(_ref => {
  let {
    viewState,
    theme,
    refForExploreMapData,
    refForUploadData
  } = _ref;
  const terria = viewState.terria;
  const {
    t,
    i18n
  } = useTranslation();
  const onAddDataClicked = e => {
    e.stopPropagation();
    viewState.setTopElement(ExplorerWindowElementName);
    viewState.openAddData();
  };
  const onAddLocalDataClicked = e => {
    e.stopPropagation();
    viewState.setTopElement(ExplorerWindowElementName);
    viewState.openUserData();
  };
  const addData = t("addData.addDataBtnText");
  const uploadText = t("models.catalog.upload");
  return /*#__PURE__*/_jsxs(Box, {
    column: true,
    styledMinHeight: "0",
    flex: 1,
    children: [/*#__PURE__*/_jsxs(_StyledDiv, {
      children: [/*#__PURE__*/_jsx(SearchBoxAndResults, {
        placeholder: applyTranslationIfExists(terria.searchBarModel.placeholder, i18n)
      }), /*#__PURE__*/_jsx(Spacing, {
        bottom: 2
      }), /*#__PURE__*/_jsxs(Box, {
        justifySpaceBetween: true,
        children: [/*#__PURE__*/_jsx(SidePanelButton, {
          ref: refForExploreMapData,
          onClick: onAddDataClicked,
          title: addData,
          btnText: addData,
          styledWidth: "152px",
          children: /*#__PURE__*/_jsx(StyledIcon, {
            glyph: Icon.GLYPHS.add,
            light: true,
            styledWidth: "20px"
          })
        }), /*#__PURE__*/_jsx(SidePanelButton, {
          ref: refForUploadData,
          onClick: onAddLocalDataClicked,
          title: t("addData.load"),
          btnText: uploadText,
          styledWidth: "152px",
          children: /*#__PURE__*/_jsx(StyledIcon, {
            glyph: Icon.GLYPHS.uploadThin,
            light: true,
            styledWidth: "20px"
          })
        })]
      }), /*#__PURE__*/_jsx(Spacing, {
        bottom: 2
      })]
    }), /*#__PURE__*/_jsx(_StyledBox2, {
      fullHeight: true,
      column: true,
      flex: 1,
      children: terria.workbench.items.length > 0 ? /*#__PURE__*/_jsx(Workbench, {
        viewState: viewState,
        terria: terria
      }) : /*#__PURE__*/_jsx(EmptyWorkbench, {
        theme: theme
      })
    })]
  });
});

// Used to create two refs for <SidePanel /> to consume, rather than
// using the withTerriaRef() HOC twice, designed for a single ref
const SidePanelWithRefs = props => {
  const refForExploreMapData = useRefForTerria(EXPLORE_MAP_DATA_NAME, props.viewState);
  const refForUploadData = useRefForTerria(SIDE_PANEL_UPLOAD_BUTTON_NAME, props.viewState);
  return /*#__PURE__*/_jsx(SidePanel, _objectSpread(_objectSpread({}, props), {}, {
    refForExploreMapData: refForExploreMapData,
    refForUploadData: refForUploadData
  }));
};
export default withTranslation()(withViewState(withTheme(SidePanelWithRefs)));
var _StyledText = styled(Text).withConfig({
  displayName: "SidePanel___StyledText",
  componentId: "sc-1eptbna-1"
})(["margin-bottom:5px;margin-top:0"]);
var _StyledUl = styled("ul").withConfig({
  displayName: "SidePanel___StyledUl",
  componentId: "sc-1eptbna-2"
})(["padding-inline-start:25px;margin:0"]);
var _StyledBox = styled(Box).withConfig({
  displayName: "SidePanel___StyledBox",
  componentId: "sc-1eptbna-3"
})(["margin-top:25px"]);
var _StyledButton = styled(Button).withConfig({
  displayName: "SidePanel___StyledButton",
  componentId: "sc-1eptbna-4"
})([""]);
var _StyledDiv = styled("div").withConfig({
  displayName: "SidePanel___StyledDiv",
  componentId: "sc-1eptbna-5"
})(["padding:0 15px;background:none;"]);
var _StyledBox2 = styled(Box).withConfig({
  displayName: "SidePanel___StyledBox2",
  componentId: "sc-1eptbna-6"
})(["overflow:hidden;"]);